<div>
  <app-base-report  *ngIf="dataSource"
                    [hasCheckboxes]="true"
                    [reportName]="'Seller Report'"
                    [defaultColumns]="defaultColumns"
                    [columnsDisplayNames]="displayTableColumns"
                    [data]="dataSource"
                    [rowsLength]="numPages"
                    [filterFields]="filterFields"
                    (filterTrigger)="filter($event)"
                    (paginationChange)="paginate($event)"
                    (searchChange)="searchChange($event)"
                    [tableLoading]="loading"
                    [selectionModel]="selectionModel"
                    [selectionActions]="selectionActions"
                    (selectionActionTrigger)="selectionActionsCB($event)"
                    [hasSort]="true"
                    (sortTrigger)="sortChange($event)"
                    [serviceInstance]="sellerReport"
                    [hasDateRangeFilter]="true"></app-base-report>
</div>
